import React, { useState } from 'react';

import styles from './onboardingStyles.scss';

import OnBoardingHeader from './OnboardingHeader/onboardingHeader';
import OnboardingSidebarContainer from 'buyside/components/container/Onboarding/OnboardingSidebarContainer';
import OnboardingForm from './OnboardingForm/onboardingForm';

import { proHome } from 'buyside/util/urlHelper';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const Onboarding = ({ watchlist, followMultiple, isAllocator, showUserDetails }) => {
  let currentPage = 1;

  if (watchlist && watchlist.onboardingStatus) {
    switch (watchlist.onboardingStatus) {
      case 'COMPLETED_SECTION_1':
        currentPage = 2;
        break;
      case 'COMPLETED_SECTION_2':
        currentPage = 3;
        break;
    }
  }
  const [page, setPage] = useState(currentPage);
  const isMobile = useIsMobile();

  const goToPage = pageNumber => {
    if (pageNumber > 3) {
      window.location.assign(proHome());
    } else {
      if (page !== pageNumber) {
        setPage(pageNumber);
        document.getElementById('onboarding-form').scrollTop = 0;
      }
    }
  };

  const handleSubmit = args => {
    const { assetClasses, geographies, sectors, fundTypes, fundStrategies, aumRanges } = args;
    const section = page;

    return followMultiple({
      variables: {
        assetClassNames: assetClasses,
        geographyNames: geographies,
        sectorNames: sectors,
        fundTypeNames: fundTypes,
        fundStrategyNames: fundStrategies,
        aumRangeNames: aumRanges,
        section
      }
    }).then(() => {
      goToPage(section + 1);
    });
  };

  return (
    <div>
      <OnBoardingHeader />
      <div className={isMobile ? styles.mobileOnboarding : styles.onboardingMainArea}>
        <OnboardingSidebarContainer
          watchlist={watchlist}
          page={page}
          isAllocator={isAllocator}
          showUserDetails={showUserDetails}
        />
        <OnboardingForm
          page={page}
          handleSubmit={handleSubmit}
          goToPage={goToPage}
          watchlist={watchlist}
          isAllocator={isAllocator}
        />
      </div>
    </div>
  );
};

export default Onboarding;
